(function() {
  document.querySelectorAll('.origo-save').forEach(saveEle => {
    saveEle.addEventListener('click', event => {
      // TODO save it to the customerFile
    });
  })

  // listen to the creation and the clicking of the "select time" button
  function observeDOMChanges() {
    const observer = new MutationObserver((mutationsList, observer) => {;
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const servicifyButton = mutation.target.querySelector('.servicify-select-a-time-button');
          if (servicifyButton) {
            servicifyButton.addEventListener('click', event => observeServicifyModalCreation(event));
            observer.disconnect();
            break;
          }
        }
      }
    });
    const productForm = document.querySelector('.product-form');
    if (productForm) {
      observer.observe(productForm, { childList: true, subtree: true });
    }
  }
  observeDOMChanges();

  // Observe the creation of the Servicify Modal after clicking the select time button
  function observeServicifyModalCreation(event) {
    let servicifyModal = document.querySelector('.Servicify-Modal');
    if (servicifyModal) {
      // If modal exists, observe the submit button
      observeSubmitButton(servicifyModal);
    } else {
      // Wait for the modal to be added to the DOM
      const observer = new MutationObserver(function(mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            const modal = mutation.target.querySelector('.Servicify-Modal');
            if (modal) {
              observeSubmitButton(modal);
              // observer.disconnect();
              break;
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Listen to the clicking of the submit button inside the modal
  function observeSubmitButton(servicifyModal) {
    // let submitButton = servicifyModal.querySelector('.product-form__submit');
    let submitButton = servicifyModal.querySelector('.servicify-modal-close');
    if (submitButton) {
      submitButton.addEventListener('click', handleSubmitClick);
    }
  }

  // Handle the click event on '.product-form__submit'
  async function handleSubmitClick(event) {
    event.preventDefault();
    let servicifyModal = event.target.closest('.Servicify-Modal');
    if (servicifyModal) {
      let servicifyForm = servicifyModal.querySelector('form');
      if (servicifyForm) {
        ensureOrigoProfile();
        // Mapping of user attributes to data-servicify attributes
        const userData = {
          firstName: 'first-name',
          lastName: 'last-name',
          email: 'email',
          phone: 'phone'
        };
        const user = window.origoProfile.session.user;

        // Loop through each field to extract and store user data
        for (let key in userData) {
          let input = servicifyForm.querySelector(`input[name="${userData[key]}"]`);
          if (input) {
            if (key === 'phone'){
              user[key] = input.value.replace(/\D/g, '');
            } else{
              user[key] = input.value;
            }
          }
        }
        const shopifyUser = await fetch(`https://oplus.cognify.ai/api/customer/create`, {
          method: 'POST',
          headers: {
            'Authorization': 'Basic b3BsdXM6ejJSbkZwaDVzd0RIZUU4S3JXYWhHZ0t6',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(user)
        });
        if (shopifyUser.ok) {
          window.origoProfile.session.customerId = shopifyUser.body.data.customerCreate.customer.id;
        }
      }
    }
  }

  // Ensure that window.origoProfile.session.user exists
  function ensureOrigoProfile() {
    if (!window.origoProfile) {
      window.origoProfile = {};
    }
    if (!window.origoProfile.session) {
      window.origoProfile.session = {};
    }
    if (!window.origoProfile.session.user) {
      window.origoProfile.session.user = {};
    }
  }

})();

/* 28 Oct 2026: the colour picker, the render and the cart props all assume a complete
   profile (session.colors, session.lastMatch). A missing or partial profile in localStorage
   killed the picker (TypeError in OrigoColors) and the render fell back to the hard-coded
   blue defaults. normalizeOrigoProfile() makes the shape complete without changing any value. */
window.normalizeOrigoProfile = function(profile) {
  if (!profile || typeof profile !== 'object') profile = {};
  if (!profile.session || typeof profile.session !== 'object') profile.session = {};
  if (!profile.session.colors || typeof profile.session.colors !== 'object') profile.session.colors = {};
  if (!profile.session.lastMatch || typeof profile.session.lastMatch !== 'object') profile.session.lastMatch = {};
  if (!profile.session.responses || typeof profile.session.responses !== 'object') profile.session.responses = {};
  return profile;
};

window.getColor = function(elementId) {
  window.origoProfile = window.normalizeOrigoProfile(window.origoProfile);
    // the includeColor logic saved a color in the session this overwrites any other logic
    const existingColor = window.origoProfile.session.colors[elementId.replace(/^ski-/, '')];
    if (existingColor?.indexOf('#') > -1) {
      return existingColor.replace(/^#/, '');
    }
  let element = document.querySelector(`[data-id="${elementId}"]`);
  if (element) {
    let checkedInput = element.querySelector(':checked')?.value;
    // return outline or full
    if (elementId === 'ski-logoType') {
      checkedInput = checkedInput || existingColor
      if (checkedInput === 'OUTLINE') {
        return 'outline';
      } else if (checkedInput === 'PATTERN'){
        if (window.origoProfile.session.colors.mod.indexOf('T') < 0) {
          window.origoProfile.session.colors.mod = window.origoProfile.session.colors.mod + 'T'
        }
        return 'logo'
      } else if (checkedInput === 'LOGO') {
        if (window.origoProfile.session.colors.mod?.indexOf('T') > -1) {
          window.origoProfile.session.colors.mod = window.origoProfile.session.colors.mod.replace(/T/g, '');
        }
        return 'logo';
      }
    }

    if (checkedInput) { return checkedInput.replace(/^#/, '');}

    const linkedElementId = element.dataset.link;
    if (linkedElementId) {
      const linkedElement = document.querySelector(`[data-id="ski-${linkedElementId}"]`);
      if (linkedElement) {
        const linkedCheckedInput = Array.from(linkedElement.querySelectorAll(':checked'));
        if (linkedCheckedInput?.value) {
          return linkedcheckedInput.substring(1);
        } else {
          return window.origoProfile.session.colors[linkedElementId.replace(/^ski-/, '')]?.replace(/^#/, '') || 'FFFFFF';
        }
      }
    }
  } else {
    return window.origoProfile.session.colors[elementId.replace(/^ski-/, '')]?.replace(/^#/, '') || 'FFFFFF';
  }
}
window.setSVG = async (setColors = false, ele) => {
  window.origoProfile = window.normalizeOrigoProfile(window.origoProfile);
  const colors = window.origoProfile.session.colors;
  // the model comes from the page first (was: a stored mod from another model, or 6X for a first-time visitor)
  const pageEle = ele || document.querySelector('[data-product-handle]');
  let handle = pageEle?.dataset.productHandle?.split('-')[2]?.toUpperCase() || colors.mod || '6X';
  if (pageEle?.dataset.productHandle) colors.mod = handle;
  if (setColors) {
    colors.logoType = window.getColor.call(this, 'ski-logoType') || 'logo';
    colors.logo = window.getColor.call(this, 'ski-logo') || '01659d';
    colors.ski = window.getColor.call(this, 'ski-ski') || '00a2df';
    colors.info = window.getColor.call(this, 'ski-info') || 'FFFFFF';
    colors.riginal = window.getColor.call(this, 'ski-riginal') || 'FFFFFF';
    colors.logoBottom = window.getColor.call(this, 'ski-logoBottom') || '01659d';
    colors.name = window.getColor.call(this, 'ski-name') || '01659d';
    colors.pattern = window.getColor.call(this, 'ski-pattern') || 'FFFFFF';
  }
  colors.text = colors.text || '';
  const imageUrl = `https://oplus.cognify.ai/api/svg/Mod${handle}.svg?ski=${colors.ski}&${colors.logoType}=${colors.logo}&info=${colors.info}&riginal=${colors.riginal}&logoBottom=${colors.logoBottom}&muster=${colors.pattern}&name=${colors.name}&text=${colors.text}`;
  await fetch(`${imageUrl}`)
          .then(response => response.text())
          .then(svgContent => {
            if (svgContent.indexOf('<svg') > -1) {
              document.querySelectorAll('.o-missing-image, .origo-product-image:has(.original-product-image-svg)').forEach(imageEle => {
                const imageSvg = imageEle.querySelector('.original-product-image-svg');
                if (imageSvg) {
                  imageSvg.innerHTML = svgContent;
                  // imageEle.classList.add('o-background-visible');
                }
                imageEle.style.setProperty('--o-blob-color', '#' + colors.logo);
                imageEle.style.setProperty('--o-blob-background-color', '#' + colors.ski);
    
              });
              window.origoProfile.session.lastMatch = window.origoProfile.session.lastMatch || {};
              window.origoProfile.session.lastMatch.img = imageUrl.replace('/svg/', '/png/').replace('.svg?', '.png?');
              // a profile without a sessionId has never been at cognify: keep it in the browser only
              if (window.origoProfile.sessionId && typeof window.updateOrigoProfile === 'function') {
                window.updateOrigoProfile();
              } else if (typeof window.storeOrigoProfile === 'function') {
                window.storeOrigoProfile();
              }
              // localStorage.setItem('origoProfile', JSON.stringify(window.origoProfile));
            }
          })
          .catch(error => {});
  // Set the color of the h3 color picker
  document.querySelectorAll('origo-colors').forEach(color => {
    if (color.querySelector('h3 .origo-color')){
      if (color.dataset.id === 'ski-logoType') {
        color.querySelector('h3 .origo-color').innerHTML = 
        `<input type="radio" class="o-variant-option"/>${color.querySelector(':checked')?.value}`;
      } else {
        color.querySelector('h3 .origo-color').style.setProperty('--o-color', color.querySelector(':checked')?.value);
      }
    }
  });  
};

window.OplusShipDate = {
  LEGACY_PROPERTY_KEYS: [
    'Delivery', 'Lieferung', 'Shipping date', 'Versanddatum',
    'Estimated shipping window:', 'Voraussichtlicher Versandzeitraum:',
    'Estimated shipping window', 'Voraussichtlicher Versandzeitraum'
  ],
  CUTOFF_HOUR: 12,
  RANGE_EXTRA_BUSINESS_DAYS: 2,

  startOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  },

  getWeekday(date) {
    const d = date.getDay();
    return d === 0 ? 7 : d;
  },

  addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return this.startOfDay(d);
  },

  skipWeekend(date) {
    const dow = this.getWeekday(date);
    if (dow === 6) return this.addDays(date, 2);
    if (dow === 7) return this.addDays(date, 1);
    return date;
  },

  addBusinessDays(fromDate, count) {
    let d = this.startOfDay(fromDate);
    for (let i = 0; i < count; i++) {
      d = this.addDays(d, 1);
      d = this.skipWeekend(d);
    }
    return d;
  },

  getShopHour(timeZone) {
    try {
      const hour = new Intl.DateTimeFormat('en-GB', {
        timeZone: timeZone || 'Europe/Vienna',
        hour: 'numeric',
        hour12: false,
      }).format(new Date());
      return Number(hour);
    } catch (e) {
      return new Date().getHours();
    }
  },

  getProcessingStartDate(cutoffHour, timeZone) {
    const now = this.todayInShopTz(timeZone);
    const hour = this.getShopHour(timeZone);
    const start = hour >= (Number(cutoffHour) || this.CUTOFF_HOUR)
      ? this.addDays(now, 1)
      : now;
    return this.skipWeekend(start);
  },

  /**
   * Processing day 1 = start date (inclusive).
   * e.g. 5 days starting Wednesday => ship on Tuesday next week? 
   * Wed=1 Thu=2 Fri=3 Mon=4 Tue=5 => Tuesday.
   */
  addInclusiveBusinessDays(startDate, count) {
    const start = this.skipWeekend(this.startOfDay(startDate));
    if (count <= 0) return start;
    return this.addBusinessDays(start, count - 1);
  },

  formatDate(date, locale) {
    const months = this.getShortMonths(locale);
    return `${months[date.getMonth()]} ${date.getDate()}`;
  },

  getShortMonths(locale) {
    const lang = String(locale || 'en').toLowerCase();
    if (lang.startsWith('de')) {
      return ['Jan.', 'Feb.', 'Mär.', 'Apr.', 'Mai', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
    }
    return ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
  },

  formatRange(fromDate, toDate, locale) {
    const sameMonth = fromDate.getMonth() === toDate.getMonth()
      && fromDate.getFullYear() === toDate.getFullYear();
    const fromText = this.formatDate(fromDate, locale);
    const toText = sameMonth
      ? String(toDate.getDate())
      : this.formatDate(toDate, locale);
    return `${fromText} – ${toText}`;
  },

  usesInStockProcessing(config) {
    if (config.inventoryManagement === 'shopify') {
      return (Number(config.inventoryQuantity) || 0) > 0;
    }
    return config.available !== false;
  },

  parseFromElement(el) {
    if (!el) return {};
    return {
      locale: el.dataset.locale,
      defaultLabel: el.dataset.defaultLabel,
      customLabel: el.dataset.customLabel,
      propertyKey: el.dataset.propertyKey,
      processingDays: el.dataset.processingDays,
      processingDaysOos: el.dataset.processingDaysOos,
      inventoryQuantity: el.dataset.inventoryQuantity,
      inventoryManagement: el.dataset.inventoryManagement,
      available: el.dataset.variantAvailable !== 'false',
      cutoffHour: el.dataset.cutoffHour,
      shopTimezone: el.dataset.shopTimezone,
    };
  },

  calculate(config) {
    const locale = config.locale || 'en';
    const inStockForProcessing = this.usesInStockProcessing(config);
    const processingDays = Number(config.processingDays) || 0;
    const processingDaysOos = Math.max(
      Number(config.processingDaysOos) || 0,
      processingDays
    );
    const daysToAdd = inStockForProcessing ? processingDays : processingDaysOos;
    const now = this.todayInShopTz(config.shopTimezone);

    let shipFrom;
    let useCustom = false;
    let label = config.defaultLabel || 'Shipping from the Alps:';

    if (config.shipmentDate) {
      const shipmentDate = this.parseISODate(config.shipmentDate);
      if (!isNaN(shipmentDate.getTime()) && shipmentDate.getTime() > now.getTime()) {
        shipFrom = shipmentDate;
        useCustom = true;
        label = config.customLabel || 'Shipping date';
      }
    }

    if (!shipFrom) {
      const processingStart = this.getProcessingStartDate(config.cutoffHour, config.shopTimezone);
      shipFrom = this.addInclusiveBusinessDays(processingStart, daysToAdd);
    }

    const shipTo = this.addBusinessDays(shipFrom, this.RANGE_EXTRA_BUSINESS_DAYS);
    const sameMonth = shipFrom.getMonth() === shipTo.getMonth()
      && shipFrom.getFullYear() === shipTo.getFullYear();
    const fromText = this.formatDate(shipFrom, locale);
    const toText = sameMonth
      ? String(shipTo.getDate())
      : this.formatDate(shipTo, locale);

    return {
      label,
      fromText,
      toText,
      dateText: `${fromText} – ${toText}`,
      rangeText: `${fromText} – ${toText}`,
      propertyKey: config.propertyKey,
      useCustom,
    };
  },

  applyToElement(el, result) {
    if (!el || !result) return;
    el.classList.toggle('custom-date', result.useCustom);
    const labelEl = el.querySelector('.deliver-text-display');
    const fromEl = el.querySelector('.delivery-date-from');
    const toEl = el.querySelector('.delivery-date-to');
    if (labelEl) labelEl.textContent = result.label;
    if (fromEl) fromEl.textContent = result.fromText;
    if (toEl) toEl.textContent = result.toText;
  },

  BASE_PROPERTY_KEY: '_ship_window_base',

  // Calendar date "YYYY-MM-DD" as a local date (no UTC shift for customers outside Europe).
  parseISODate(value) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
    if (!m) return new Date(NaN);
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  },

  // Today's date in the shop time zone (Vienna), independent of the customer's device clock.
  todayInShopTz(timeZone) {
    const d = this.parseISODate(this.getShopTodayISO(timeZone));
    return isNaN(d.getTime()) ? this.startOfDay(new Date()) : d;
  },

  getShopTodayISO(timeZone) {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: timeZone || 'Europe/Vienna',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  },

  getShipWindowBaseISO(timeZone, offsetDays) {
    const today = this.getShopTodayISO(timeZone);
    const offset = Number(offsetDays) || 0;
    if (offset <= 0) return today;
    const d = new Date(`${today}T12:00:00Z`);
    d.setUTCDate(d.getUTCDate() - offset);
    return d.toISOString().slice(0, 10);
  },

  isShipWindowStale(baseISO, staleAfterDays, timeZone) {
    if (!baseISO || !/^\d{4}-\d{2}-\d{2}$/.test(String(baseISO))) return true;
    const today = this.getShopTodayISO(timeZone);
    const base = new Date(`${baseISO}T12:00:00Z`);
    const tod = new Date(`${today}T12:00:00Z`);
    if (isNaN(base.getTime()) || isNaN(tod.getTime())) return true;
    const diffDays = Math.floor((tod.getTime() - base.getTime()) / 86400000);
    return diffDays >= (Number(staleAfterDays) || 1);
  },

  findShipWindowInProperties(properties, propertyKey) {
    if (!properties) return { key: null, value: null };
    if (propertyKey && properties[propertyKey]) {
      return { key: propertyKey, value: properties[propertyKey] };
    }
    const keys = [propertyKey].concat(this.LEGACY_PROPERTY_KEYS).filter(Boolean);
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      if (properties[k]) return { key: k, value: properties[k] };
    }
    return { key: null, value: null };
  },
};

class OriginalElement extends HTMLElement{
  constructor(){
    super();
  }
  processMetaObjectText(variantId, meta_object_text, value) {
    
    if (!meta_object_text) {
      return value;
    }
    // Grab the map of keys/values for the given variantId
    const variantMetafields = this.getVariantsMetafields()[variantId] || {};
    // Regex for both  and [[...]]
    const pattern = /(\{\{\s*([^}]+?)\s*\}\}|\[\[\s*([^\]]+?)\s*\]\])/g;
  
    const processedText = meta_object_text.replace(pattern, (match, _fullMatch, curlyKey, bracketKey) => {
      const key = curlyKey || bracketKey;
      const originalValue = variantMetafields[key];
      
      // If there's no value, replace with empty string
      if (originalValue === undefined || originalValue === null) {
        return '';
      }
      
      // Special case for values that look like ranges (e.g. "410-430")
      if (typeof originalValue === 'string' && originalValue.indexOf('-') > -1) {
        return originalValue;
      }
      
      // Try parsing the value as float
      const floatVal = parseFloat(originalValue);
      // Check if parseFloat succeeded and if the value is effectively an integer
      if (!isNaN(floatVal)) {
        const intVal = parseInt(originalValue, 10); 
        // If the float matches the integer (e.g. "12.0"), use the int only
        if (floatVal === intVal) {
          return intVal.toString();
        }
      }
      // Otherwise return the original value (string or not purely integer)
      return originalValue;
    });
    return processedText;
  }

  renderAddon(){
    this.dataset.metafieldOptions = this.getVariantsMetafields()[window.oplus.currentVariant.id][this.dataset.name];
      // All possible addons are in a script tag in original-product-advantage.liquid, because it is impossible to query a product by SKU in the Store API
      this.addonList = JSON.parse(this.closest('.o-product-addon').querySelector('.allVariantAddons').textContent);
      const addonSelectEle = this.querySelector('.o-addon-select');
      let emptyOptionIndex;
      let emptyOption;
      let emptyOptionEle;
      const allOldOptions = addonSelectEle.querySelectorAll('[value]');
      allOldOptions.forEach((option, index) => {
        if (!option.value || option.value.length < 1){
          emptyOption = option;
          emptyOptionIndex = index > 0 || allOldOptions.length === 1 ? 'last' : 'first';
          emptyOptionEle = option.tagName == "INPUT" ? option.closest('.o-addon-label') : option;
        }
      });

      const idList = [];
      const checkedOption = addonSelectEle.querySelector(':checked');
      // remove all options except the empty option
      addonSelectEle.querySelectorAll('.o-addon-option').forEach(option => {
        if (option.tagName === 'INPUT' && option !== emptyOption){
          addonSelectEle.removeChild(option.closest('.o-addon-label'));
        } else if (option.tagName === 'OPTION' && option !== emptyOption){
          addonSelectEle.removeChild(option);
        }
      });

      let addons = this.dataset.metafieldOptions.split(",");
      addons =  addons == 'undefined' || !addons || addons.length < 1 ? Object.keys(this.addonList) : addons
      addons.forEach((sku, index) => {
        const addon = this.addonList[sku];
        // only add the option if it is not already available
//        if (this.querySelector(`[data-variant-id="${addon.id}"]`)){ return }

        if (addon){
          idList.push(addon.productId.toString());
          let newOption = document.createElement("option");
          const label = document.createElement("label");
          if (addonSelectEle.tagName === 'FIELDSET') {
            newOption = document.createElement("input");
            newOption.setAttribute("type", "radio");
            newOption.setAttribute("name", this.dataset.name.replace(/\s+/g, ''));
            label.classList.add('o-addon-label');
            label.innerHTML = `<span class="o-addon-label-title">${addon.name}</span><span class="o-addon-label-texts"><span class="o-addon-description">${addon.description || ""}</span><span class="o-addon-price-difference">${this.closest('original-product').dataset.currency + " " + addon.price / 100}</span></span>`
          }
          newOption.classList.add('o-addon-option');
          newOption.value = addon.productId;
          if (newOption.value === checkedOption?.value){
            addonSelectEle.value = newOption.value;
            if (addonSelectEle.tagName === 'SELECT'){
              newOption.selected = 'selected';
            }
            newOption.checked = true;
          }
          newOption.setAttribute("data-price", addon.price / 100);
          newOption.setAttribute("data-title", addon.name);
          newOption.setAttribute("data-variant-id", addon.id);
          let addElement = newOption;
          if (addonSelectEle.tagName === 'FIELDSET'){
            label.appendChild(newOption);
            addElement = label;
            if (emptyOptionIndex === 'last'){
              const childElements = Array.from(addonSelectEle.children);
              const emptyOptionEleIndex = childElements.indexOf(emptyOptionEle);
              addonSelectEle.insertBefore(addElement, addonSelectEle.children[emptyOptionEleIndex]);
            } else{
              addonSelectEle.appendChild(addElement)
            }
          } else {
            newOption.textContent = addon.name;
            if (emptyOptionIndex === 'last'){
              addonSelectEle.insertBefore(addElement, emptyOption)
            } else{
              addonSelectEle.appendChild(addElement)
            }
          }
        }
      });

      let firstOption = addonSelectEle.querySelectorAll('.o-addon-option')[0];
      // if the last option is checked, check the first option (to avoid the "none" option)
      const entries = Array.from(addonSelectEle.querySelectorAll('.o-addon-option'));
      if ( entries.length > 1 && (entries[entries.length - 1].selected || entries[entries.length - 1].selected === 'selected')){
        if (firstOption){
          if (addonSelectEle.tagName === 'SELECT'){
            addonSelectEle.value = firstOption.value;
            firstOption.selected = 'selected';
            firstOption.checked = true;
          }
        }
      }
      // if binding is recommended, move it to the top
      const session = window.origoProfile?.session;
      const lastMatch = session?.lastMatch;
      const addonElements = addonSelectEle.querySelectorAll('.o-addon-option');
      if (lastMatch && lastMatch.matches?.indexOf(this.closest('original-product').dataset.variantSku) > -1) {
        for (const lastMatchSku of [lastMatch.binding, lastMatch.finish, lastMatch.tuning, session.responses?.tipprotector]){
          if (!lastMatchSku) continue;
          const recommendedAddonId = this.addonList[lastMatchSku]?.id;
          if (!recommendedAddonId || (!recommendedAddonId && lastMatchSku !== 'none')) continue;
          for (const addonEle of addonElements) {
            if (addonEle.dataset.variantId === recommendedAddonId?.toString() || (lastMatchSku === 'none' && !addonEle.dataset.variantId)) {
              const elementToMove = addonEle.tagName === 'OPTION' ? addonEle : addonEle.closest('.o-addon-label');
              addonSelectEle.insertBefore(elementToMove, addonSelectEle.firstChild)
              firstOption = elementToMove.querySelector('.o-addon-option');
              firstOption.checked = true;
              break;
            }
          }
        }
      }
      // if no option is checked, check first option
      if (!addonSelectEle.querySelector(':checked') && firstOption){
        firstOption.checked = true;
      }
      // Add first option tag only if it is not already present
      if (addonSelectEle.dataset.firstOptionTag?.length > 0){
        const firstOption = addonSelectEle.querySelector('.o-addon-label');
        if (firstOption &&!firstOption?.querySelector('.addon-first-option-tag')){
          for (const optionTag of addonSelectEle.querySelectorAll('.addon-first-option-tag')){
            optionTag.remove();
          }
          const spanElement = document.createElement('span');
          spanElement.className = 'addon-first-option-tag';
          spanElement.innerHTML = addonSelectEle.dataset.firstOptionTag;
          firstOption.insertBefore(spanElement, firstOption.firstChild);
        }
      }
      const remainingOptions = addonSelectEle.querySelectorAll('.o-addon-option');
      if (remainingOptions.length > 0) {
        // addonSelectEle.value = remainingOptions[0].value;
        const changeEvent = new Event('change', {
          bubbles: true, // Ensure the event bubbles up
          cancelable: true // Ensure the event can be canceled
        });
        addonSelectEle.dispatchEvent(changeEvent);
      }
      const customTextEle = this.querySelector('fieldset[name="customtext"]');
      if (customTextEle && customTextEle?.dataset.productSku?.length > 0 && customTextEle?.dataset.variantId !== 'undefined') {
        if (!window.origoProfile?.session?.colors) return;
        let nonOptionEle;
        customTextEle.querySelectorAll('.o-addon-option').forEach(optionEle => {
          const label = optionEle.closest('.o-addon-label');
          // set the name of the option to the color text
          if (optionEle.value){
            optionEle.dataset.name = window.origoProfile.session.colors.text;
            if (label){
              const textInputEle = document.createElement('input');
              textInputEle.type = 'text';
              textInputEle.classList.add('o-custom-text');
              textInputEle.placeholder = 'Max 9';
              textInputEle.max = 9;
              textInputEle.value = window.origoProfile.session.colors.text || '';
              textInputEle.addEventListener('input', () => {
                if (textInputEle.value.length > 0){
                  optionEle.checked = true;
                } else {
                  nonOptionEle.checked = true;
                }
                  textInputEle.value = textInputEle.value.slice(0, 9);
                window.origoProfile.session.colors.text = textInputEle.value;
                optionEle.dataset.name = textInputEle.value;
                window.origoProfile.session.responses.ski_text = textInputEle.value;
                const imageEle = this.closest('original-product').querySelector('.o-missing-image');
                window.setSVG(false, imageEle).then();
              });

              customTextEle;
              label.querySelector('.o-addon-description').appendChild(textInputEle);
            }
          } else {
            nonOptionEle = optionEle;
          }
          // set the color text to the value of the option
          label.addEventListener('click', () => {
            optionEle.checked = true;
            label.dispatchEvent(new Event('change', { bubbles: true }));
            if (!optionEle.value){
              window.origoProfile.session.colors.text = '';
              window.origoProfile.session.responses.ski_text = '';
            } else {
                window.origoProfile.session.responses.ski_text = window.origoProfile.session.colors.text = optionEle.dataset.name;
            }
            const imageEle = this.closest('original-product').querySelector('.o-missing-image');
            window.setSVG(false, imageEle).then();
          });
        });
        if (!window.origoProfile.session.colors.text){
          nonOptionEle.checked = true;
          nonOptionEle.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
  }
  // Needed to convert a javascript object to a JSON string
  parseAsJSObject(str) {
    return new Function(`return (${str});`)();
  }

  getSectionEle(){
    this.sectionEle = this.sectionEle || document.getElementById(`shopify-section-${this.dataset.section}`) || this.closest('[id*="shopify-section"]');
    return this.sectionEle
  }

  updateOptions() {
    // Step 1: Select all elements with the class '.o-product-variant-select'
    const elements = Array.from(this.getSectionEle().querySelectorAll('.o-product-variant-select'));
    // Step 2: Sort the elements based on the 'data-position' attribute
    elements.sort((a, b) => {
      const positionA = parseInt(a.getAttribute('data-position'), 10);
      const positionB = parseInt(b.getAttribute('data-position'), 10);
      return positionA - positionB;
    });
    // Step 3: Update the this.options array with the sorted elements
    window.oplus.options = elements.map((element) => {
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      } else{
        return element.value;
      }
    }).filter(value => value !== undefined); // Filter out undefined values;
    if (!window.oplus.options || window.oplus.options.length === 0){
      const productEle = this.closest('original-product');
      const variantSKU = productEle.dataset.variantSku;
      window.oplus.options = this.getVariantData().find((variant) => variant.sku === variantSKU).options;
    };
  }
  updateMasterId() {
    if (!window.oplus) window.oplus = {};
    this.updateOptions();
    window.oplus.currentVariant = this.getVariantData()?.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return window.oplus.options[index] === option;
        })
        .includes(false);
    });
  }

  getProductImage() {
    this.productImage = JSON.parse(this.getSectionEle().querySelector('#variantData').textContent)[0].image 
  }

  getVariantData(){
    const variantDataEle = this.getSectionEle().querySelector('#variantData')
    if (!variantDataEle || !variantDataEle.textContent) return;
    this.variantData = this.variantData || JSON.parse(this.getSectionEle().querySelector('#variantData').textContent)[0].variants;
    return this.variantData;
  }
  getVariantsMetafields(){
    this.variantsMetafields = this.variantMetafields || JSON.parse(this.getSectionEle().querySelector('#variantData').textContent)[0].metafields.variantsCustom;
    return this.variantsMetafields;
  }

  getProductEle(){
    this.productEle = this.productEle || this.closest('.o-product');
    return this.productEle;
  }

  setModal(){
    const addonInfoEle = this.querySelector('.o-modal-open');
    if (addonInfoEle){
      addonInfoEle.addEventListener('click', () =>{
        this.getProductEle()?.querySelectorAll(':scope > .o-addons-modal-overlay')?.forEach(el => {el.remove();});
        const modalEle = this.querySelector('.o-addons-modal-overlay');
        this.getProductEle()?.insertAdjacentHTML('beforeend', modalEle.outerHTML);

        setTimeout(() => {
          this.getProductEle()?.classList.add('o-addons-modal-visible');
        }, 32);
        const closeModal = () => {
          this.getProductEle()?.classList.remove('o-addons-modal-visible');
          setTimeout(() => {
            newModalEle.remove();
          }, originalTimeoutDuration);
        };
        const newModalEle = this.getProductEle()?.querySelector(':scope > .o-addons-modal-overlay');
        if (newModalEle){
          newModalEle.addEventListener('click', (event) => {
            if (event.target.classList.contains('o-addons-modal-overlay')) {
              closeModal();
            }
          });
        }
        const closeButton = newModalEle.querySelector('#modal-close-button');
        if (closeButton) {
          closeButton.addEventListener('click', closeModal);
        }
      });
    }
  }
}

customElements.define('original-element', OriginalElement);
class OriginalAddon extends OriginalElement{
  constructor(){
    super();
    this.selectEle = this.querySelector('.o-addon-select');
    this.addEventListener('change', this.addonChangeHandler);
    document.addEventListener('profileLoaded', () => {
      this.renderAddon();
    });
    this.setModal();
  }

  initBindingObserver() { 
    const options = {
      rootMargin: '20px',
      root: null
    }

    this.observer = new IntersectionObserver(this.observerCallback.bind(this), options)
    this.observer.observe(this)
  }

  observerCallback(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.setAttribute('show-notice', true)
        this.observer.unobserve(entry.target)
        this.observer.disconnect()
      }
    })
  }

  showBindingNotice(evt) {
    const inputSelector = 'input[type="radio"][name="bindung"]'
    
    if (evt.target?.matches(inputSelector) || evt.target.querySelector(inputSelector)) { 
      this.removeNotice()
      const input = evt.target.tagName === 'INPUT' ? evt.target : evt.target.querySelector(inputSelector) 
      if (input.value?.length === 0 || !input.value) return
      const parentLabel = input.closest('label.o-addon-label')
      const bindingNotice = this.closest('original-product').dataset.bindingNotice 
      this.noticeEl = this.createNotice()
      this.noticeEl.innerText = bindingNotice 
      
      parentLabel.appendChild(this.noticeEl)
      
      window.addEventListener('click', this.handleOutsideClick.bind(this)) 
    }
  }

  createNotice() {
    const noticeEl = document.createElement('span')
    noticeEl.classList = 'notice'
    return noticeEl
  }

  handleOutsideClick() {
    this.removeNotice()
  }

  removeNotice() { 
    this.noticeEl?.remove()
    window.removeEventListener('click', this.handleOutsideClick.bind(this))
  }

  addonChangeHandler(evt){
    this.getProduct().then(); 
    if (this.closest('original-product').type === 'racing') this.showBindingNotice(evt)
  }

  async getProduct() {
    const now = Date.now();
    const priceEle = this.getSectionEle().querySelector(".o-product-price [class*='price-number']");
    const priceTextEle = this.getSectionEle().querySelector(".price-text");
    if (this.bottomTagElement){animateElementChange(this.bottomTagElement);}
    if (priceEle){animateElementChange(priceEle);}
    if (priceTextEle){animateElementChange(priceTextEle);}

    let checkedId = this.selectEle.querySelector(':checked')?.value.toString();
    if (!this.selectEle.querySelector(':checked')){
      checkedId = this.selectEle.querySelector('.o-addon-option').value.toString();
    }

    const addon = Object.values(this.addonList).find(p => p.productId.toString() === checkedId?.toString());
    this.selectEle.setAttribute('data-variant-id', addon?.id);
    this.selectEle.setAttribute('data-product-sku', addon?.sku || '');
    this.selectEle.setAttribute('data-addon-price', addon?.price || '')

    const newTime = Date.now();
    let timeRemaining = originalTimeoutDuration - (newTime - now);
    if (timeRemaining < 0){ timeRemaining = 0; }
    setTimeout(()=>{
      // Match / No match texts
      if (priceTextEle?.dataset.dependency){
        const addonValue = this.getSectionEle().querySelector(`[data-name="${priceTextEle.dataset.dependency.toLowerCase()}"] :checked`)?.value;
        priceTextEle.innerHTML = addonValue ? priceTextEle.dataset.match : priceTextEle.dataset.noMatch;
      }
/*      const separator = this.closest('.o-product').dataset.separator;
      const index = separator.indexOf('2');
      if (index !== -1 && index + 1 < separator.length) {
        const thousandSeparator = separator[index + 1];
      }
*/
      // Find price
      let newPrice = +this.selectEle.dataset.productPrice;
      this.closest('.o-product').querySelectorAll(`.o-addon-select[data-product-id="${this.selectEle.dataset.productId}"]`).forEach(sele => {
        const addonPrice = sele.querySelector('.o-addon-option:checked')?.dataset.price;
        if (addonPrice){newPrice = newPrice + (+addonPrice * 100);}
      });
      // Set price
      if (priceEle && newPrice > 0){
        priceEle.innerHTML = (newPrice / 100).toLocaleString();
      }
      // Set bottom tag
      if (this.bottomTagElement) {
        const innerHTML = addon? addon.description : ' ';
        this.bottomTagElement.innerHTML = innerHTML ? innerHTML : '';
      }
      // clean up empty product-advantages
      this.querySelectorAll('.o-product-advantage').forEach(ele => {
        ele.parentElement.style.display = ele.querySelector('.o-product-benefit') ? 'unset' : 'none';
      });
    }, timeRemaining)

    // Set price difference for each option
    if (this.selectEle.dataset.showPriceDifference === 'true'){
      const checkedOption = this.selectEle.querySelector(':checked');
      const optionElements = this.querySelectorAll('.o-addon-option');
      for (const optionElement of optionElements) {
        let priceDifference = optionElement.dataset.price - checkedOption.dataset.price;
        if (priceDifference > 0){
          priceDifference = "+" + this.closest('original-product').dataset.currency + " " + priceDifference.toString();
        } else if (priceDifference < 0){
          priceDifference = this.closest('original-product').dataset.currency + " " + priceDifference.toString();
        } else {
          priceDifference = "";
        }
        if (optionElement.tagName === 'OPTION'){
          priceDifference = priceDifference.length > 0 ? " (" + priceDifference + ")" : '';
          optionElement.innerText = optionElement.dataset.title + priceDifference;
        } else if (optionElement.dataset.price + 1 > 1){
          optionElement.closest('.o-addon-label').querySelector('.o-addon-price-difference').innerText = this.closest('original-product').dataset.currency + " " + optionElement.dataset.price;
        }
      }
    }
  }
}
customElements.define('original-addon', OriginalAddon);

const originalTimeoutDuration = 300;
function animateElementChange(ele){
  ele.style.setProperty('opacity', 0);
  setTimeout(() => {
    ele.style.setProperty('opacity', 1);
  },originalTimeoutDuration + 200)
}

class OriginalProduct extends OriginalElement {
  constructor(){
    super();
    this.updateMasterId();
    let storedProfile = null;
    try { storedProfile = JSON.parse(localStorage.getItem('origoProfile')); } catch (e) { storedProfile = null; }
    window.origoProfile = window.normalizeOrigoProfile(storedProfile);
    document.dispatchEvent(new Event('profileLoaded'));
    this.type = this.dataset.type

    this.productForm = this.querySelector(`#product-form-${this.dataset.section}`);
    this.productForm.addEventListener('submit', this.addCartHandler.bind(this))
    this.cartIcon = document.getElementById('cart-icon-bubble') || document.querySelector('.cart-link__bubble');
    this.setConfigureButton();

    this.comparisonButton = this.closest('section').querySelector('#o-comparison-button');
    if (this.comparisonButton){
      this.comparisonButton.addEventListener('click', this.comparisonButtonHandler.bind(this));
    }
    this.comparisonOverlay = this.closest('.section').querySelector('#o-comparison-overlay')
    if (this.comparisonOverlay){
      this.comparisonOverlay.addEventListener('click', this.comparisonButtonHandler.bind(this));
    }
    this.atcButton = this.querySelector('.add-to-cart')
    this.setLinks();
    this.setFinalPrice();
    this.setVariants();
    setTimeout(() => {window.setSVG(true).then()}, 150);
  }
  setLinks(){
    if (this.classList.contains('o-read-only')) {
      const linkElements = this.querySelectorAll('.o-product-advantage');
      linkElements.forEach(linkEle => {
        const id = linkEle.dataset.name.toLowerCase();
        linkEle.addEventListener('click', event => {
          const targetEle = document.getElementById(`o-product-textblock-${id}`);
          if (targetEle) {
            targetEle.scrollIntoView({
              behavior: 'smooth',
            });
          }
        });
      });
    }

  }
  setVariants(){
    const variantElements = this.getSectionEle().querySelectorAll('.o-product-variant-select');
    if (variantElements.length < 1) return;
    const variantDataEle = this.getSectionEle().querySelector('#variantData');
    if (!variantDataEle || !variantDataEle.textContent) return;
    const variantData = JSON.parse(variantDataEle.textContent)[0].variants
    if (variantData.length < 1) return;
    const options = variantElements[0].querySelectorAll('.o-variant-option');
    for (const option of options) {
      option.dataset.outOfStock = 'true';
      for (const variant of variantData) {
        if (variant[`option${variantElements[0].dataset.position}`] === option.value && variant.available) {
          option.dataset.outOfStock = 'false';
          break;
        }
      }
    }
  }
  comparisonButtonHandler(){
    this.classList.toggle('o-comparison-visible');
    if (this.comparisonOverlay && this.classList.contains('o-comparison-visible') && !this.comparisonOverlay.classList.contains('o-comparison-visible')) {
      // show the overlay
      this.comparisonOverlay.classList.add('o-comparison-modal-visible');
      setTimeout(() => {
        this.classList.add('o-fade-in');
        this.comparisonOverlay.classList.add('o-fade-in');
        }, 100);
      // prevent clicks in the original-product element from propagating to the overlay
      this.addEventListener('click', event => event.stopPropagation());
    } else {
      this.comparisonOverlay.classList.remove('o-comparison-modal-visible');
      this.classList.remove('o-fade-in');
      this.comparisonOverlay.classList.remove('o-fade-in');
    }
  }
  addCartHandler(e){
    e.preventDefault();
    this.sendAddCart();
  };
  setFinalPrice(){
    // Product & product2 are considered
    const priceElements = this.getSectionEle().querySelectorAll(".o-product-price");
    if (!priceElements) return;
    priceElements.forEach(priceEle => {
      const priceNumberEle = priceEle.querySelector(".price-number");
      let newPrice = parseFloat(priceNumberEle.dataset.price);
      this.querySelectorAll(`.o-addon-select[data-product-id="${priceNumberEle.dataset.productId}"]`).forEach(selectEle => {
        const checkedEle = selectEle.querySelector(':checked');
        if (checkedEle?.dataset.price){
          newPrice = newPrice + +checkedEle.dataset.price * 100;
        }
      });
      if (priceNumberEle && newPrice > 0){
        priceNumberEle.innerHTML =  (newPrice / 100).toLocaleString();
      }
      const priceTextEle = priceEle.querySelector(".price-text");
      if (priceTextEle?.dataset.dependency){
        const addonValue = this.getSectionEle().querySelector(`[data-name="${priceTextEle.dataset.dependency.toLowerCase()}"] .o-addon-select :checked`)?.value;
        priceTextEle.innerHTML = addonValue ? priceTextEle.dataset.match : priceTextEle.dataset.noMatch;
      }
    });
    // clean up empty product-advantages
    this.querySelectorAll('.o-product-advantage').forEach(ele => {
      ele.parentElement.style.display = ele.querySelector('.o-product-benefit') ? 'unset' : 'none';
    });
  } 

  sendAddCart(){
    const formData = {'items': []};
    
    const flexIntelElement = document.getElementById('FlexIntelForm')
    let shouldCheckForBindings = flexIntelElement !== null 

    const productId = this.productForm.querySelector('input[name="id"]').value;
    if (productId){
      formData.items.push({'id': productId, 'quantity': 1, 'properties': {}});
    }
    const addonsSelect = this.querySelectorAll(`.o-addon-select`); // [data-product-id="${this.selectEle.dataset.productId}"]
    const formProduct = formData.items.find(item => item.id === productId);
    for (const selectEle of addonsSelect) {
      const checkedEle = selectEle.querySelector(':checked');
      if (!checkedEle || !checkedEle.dataset.variantId) continue;

      // add the addon to the beginning of the formData (important for the order)
      formData.items.unshift({ 
        'id': checkedEle.dataset.variantId, 
        'quantity': 1,
        'properties': {
          '_parent_item': this.dataset.variantSku || productId
        }
      });

      // add the addon sku to the ski as private property
      const sku = checkedEle.dataset.addonSku;
      if (sku){
        formProduct.properties[`_${selectEle.name}-sku`] = checkedEle.dataset.addonSku;
      } else {
        formProduct.properties[`_${selectEle.name}-id`] = checkedEle.dataset.variantId;
      }
      // --- REVERT START: Origo custom image only on ski-product-custom ---
      // Was: always wrote lastMatch.img when any addon was selected (leaked onto SELECT/etc from localStorage).
      // Gate uses data-type from template.suffix on <original-product>.
      if (this.dataset.type === 'ski-product-custom' && window.origoProfile?.session?.lastMatch?.img) {
        formProduct.properties['_custom-image'] = window.origoProfile.session.lastMatch.img;
      }
      // --- REVERT END: Origo custom image only on ski-product-custom ---
    }

    if (flexIntelElement) {   
      if (!flexIntelElement.hasAttribute('success')) {  
        flexIntelElement.scrollIntoView({ behavior: 'smooth' }) 
        flexIntelElement.renderError('cart')
        return
      } else {
        formProduct.properties['_flex-intel'] = flexIntelElement.intelData
        formProduct.properties['_racing-product'] = true 
      }
    }

    // --- REVERT START: Origo color props only on ski-product-custom ---
    // Was: og:title indexOf('custom') (buggy: -1 is truthy) + any cached session.colors.
    // Gate uses data-type from template.suffix on <original-product>.
    if (this.dataset.type === 'ski-product-custom' && window.origoProfile?.session?.colors?.ski) {
      const colors = window.origoProfile.session.colors;
      for (const color in colors) {
        formProduct.properties[`_${color}`] = this.getColors()[colors[color]] || colors[color];
      }
    }
    // --- REVERT END: Origo color props only on ski-product-custom ---
    // add expected ship date as a visible line item property
    const datesEle = this.getSectionEle()?.querySelector('.delivery-dates');
    if (datesEle) {
      const variant = window.oplus?.currentVariant;
      const shipmentDate = variant?.id
        ? this.getVariantsMetafields()[variant.id]?.shipment_date
        : null;
      const result = window.OplusShipDate.calculate({
        ...window.OplusShipDate.parseFromElement(datesEle),
        shipmentDate,
        inventoryQuantity: variant?.inventory_quantity,
        inventoryManagement: variant?.inventory_management,
        available: variant?.available,
      });
      window.OplusShipDate.applyToElement(datesEle, result);
      window.OplusShipDate.LEGACY_PROPERTY_KEYS.forEach((key) => {
        delete formProduct.properties[key];
      });
      if (result.propertyKey) {
        formProduct.properties[result.propertyKey] = result.dateText;
        const testOffset = Number(window.theme?.settings?.shipWindowTestOffsetDays) || 0;
        formProduct.properties[window.OplusShipDate.BASE_PROPERTY_KEY] =
          window.OplusShipDate.getShipWindowBaseISO('Europe/Vienna', testOffset);
      }
    }

    if (formData?.items?.length > 0) {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          return response.json();
        }).then((response) => {
        if (response.status === 422) {
          console.error(response.message);
          return;
        }
        if (response?.items?.length > 0){
          this.snowflakeAnimation();
          setTimeout(() => {
            if (window.theme?.settings.cartType === 'page') {
              window.location = window.theme.routes.cartPage;
            }
          }, 1000)
        }
        if (this.cartIcon) {
          let cartCountBubble = this.cartIcon.querySelector('.cart-count-bubble');
          let currentCount = 0;
          if (cartCountBubble) {
            let countSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
            currentCount = parseInt(countSpan.textContent, 10);
          } else {
            cartCountBubble = document.createElement('div');
            cartCountBubble.className = 'cart-count-bubble';
            let countSpan = document.createElement('span');
            countSpan.setAttribute('aria-hidden', 'true');
            cartCountBubble.appendChild(countSpan);
            let hiddenSpan = document.createElement('span');
            hiddenSpan.className = 'visually-hidden';
            cartCountBubble.appendChild(hiddenSpan);
            this.cartIcon.appendChild(cartCountBubble);
          }
          let newCount = currentCount + response.items.length;
          cartCountBubble.querySelector('span[aria-hidden="true"]').textContent = newCount;
          cartCountBubble.querySelector('.visually-hidden').textContent = `${newCount} items`;
        }
      });
    }
  }
  getSectionEle(){
    this.sectionEle = this.sectionEle || document.getElementById(`shopify-section-${this.dataset.section}`)
    return this.sectionEle
  }
  snowflakeAnimation(){
    const jsConfetti = new JSConfetti();
    jsConfetti.addConfetti({
      emojis: ['❄️'], // Use the emoji as confetti
      emojiSize: 30,
      confettiNumber: 90, // Number of confetti particles
    });
  }
  getColors(){
    this.colors = this.colors || JSON.parse(document.getElementById('colorData').textContent);
    return this.colors;
  }

  setConfigureButton(linkToProductPage) {
    const configureButton = this.querySelector('#configure');
    if (!configureButton) return;

    if (configureButton.dataset.link === 'product_page'){
      configureButton.setAttribute('href', window.origoProfile.session.lastMatch.productUrl);
      return;
    }

    let url = window.origoProfile?.session?.lastMatch?.url;
    const shopRoot = Shopify?.routes?.root?.slice(0, -1) || '';

    // If no URL stored, fall back to generic origo page (with sessionId and optional current view)
    if (!url) {
      if (window.origoProfile?.sessionId) {
        const params = new URLSearchParams();
        params.set('sessionId', window.origoProfile.sessionId);
        configureButton.setAttribute('href', `${shopRoot}/pages/origo?${params.toString()}`);
      } else {
        configureButton.remove();
      }
      return;
    }

    // Normalize legacy pattern if present
    if (url.indexOf('origosessionId') > -1) {
      url = url.replace('origosessionId', 'origo?sessionId');
    }

    try {
      const base = `${window.location.origin}${shopRoot}`;
      const u = new URL(url, base);

      const view = u.searchParams.get('view');
      u.search = '';
      if (view !== null) u.searchParams.set('view', view);

      if (window.origoProfile?.sessionId) {
        u.searchParams.set('sessionId', window.origoProfile.sessionId);
      }

      // Create a shop-relative href
      const href = `${shopRoot}${u.pathname.replace(shopRoot, '')}${u.search}`;
      configureButton.setAttribute('href', href);
    } catch (e) {
      // Fallback: manual reconstruction if URL() fails
      const qIndex = url.indexOf('?');
      const path = qIndex >= 0 ? url.slice(0, qIndex) : url;
      const search = qIndex >= 0 ? url.slice(qIndex) : '';
      const sp = new URLSearchParams(search);
      const view = sp.get('view');
      const out = new URLSearchParams();
      if (view !== null) out.set('view', view);
      if (window.origoProfile?.sessionId) out.set('sessionId', window.origoProfile.sessionId);
      const finalUrl = `${path}${out.toString() ? `?${out.toString()}` : ''}`;
      configureButton.setAttribute('href', `${shopRoot}${finalUrl}`);
    }
  }
}
customElements.define('original-product', OriginalProduct);

class OriginalVariant extends OriginalElement {
  constructor() {
    super();

    this.addEventListener('change', this.onVariantChange);
    this.initializeVariant();
    document.addEventListener('profileLoaded', () => {
      this.initializeVariant();
    });
    this.handlePromoNotification()
  }

  connectedCallback() {
    this.variantDataObject = JSON.parse(document.getElementById('variantData')?.textContent)
    this.productTitle = this.variantDataObject
  }

  handlePromoNotification() { 
    try {
      if (this.notice) this.removeNotice(this.notice)
      
      const variantID = window.oplus.currentVariant.id;
      (!this.promoVariantsMO) && (this.promoVariantsMO = JSON.parse(this.getSectionEle().querySelector('#variantData').textContent)[0].metafields.promoted_variants_group)
      if (!this.promoVariantsMO) {
        return
      } 
      
      const option_handle = this.promoVariantsMO.notification_option_handle
      
      const optionWrapper = this.closest('original-product').querySelector(`.o-product-variant-select[name="${option_handle}"]`) 
      const promotedVariant = this.getVariantsMetafields()[variantID].promoted_variant
      
      let url_params = ''
      if (promotedVariant && promotedVariant?.length > 5) {
        url_params = '?variant=' + promotedVariant.split('Variant/')[1]
      }

      function renderRichText(node) {
        if (!node) return ''

        switch (node.type) {
          case 'root':
            return node.children.map(renderRichText).join('')

          case 'paragraph':
            return `<p>${node.children.map(renderRichText).join('')}</p>`

          case 'text':
            return node.value

          case 'link':
            const content = node.children.map(renderRichText).join('')
            return `<a href="${node.url + url_params}" title="${node.title || ''}">${content}</a>`

          default:
            return ''
        }
      }
      
      const showNotification = this.promoVariantsMO.promoted_variants.find(variant => variant.includes(variantID)) ?? false 
      if (showNotification) {
        this.noticeEl = this.createNotice()
        const richText = renderRichText(this.promoVariantsMO.notification_text)
        this.noticeEl.innerHTML = richText
        optionWrapper.appendChild(this.noticeEl)
      }
    } catch(error) {
      console.log('ERROR handling promotion: ', error)
    }
    
  }

  onVariantChange(e) {
    this.getSectionEle();
    this.updateMasterId();
    this.updateVariantStatuses();
    this.updateShippingDates()
    this.updateURL();
    this.updateVariantInput();
    this.getSectionEle().querySelectorAll('[data-metafield-options]').forEach((ele) => {
      this.renderAddon.call(ele);
    });

    this.renderProductInfo();
    this.updateShareUrl();
    this.handlePromoNotification()
    this.updateImage()
  }

  updateImage() {
    try {
      const variantID = window.oplus.currentVariant.id; 
      const variantData = this.variantData.find(variant => variant.id === variantID);
      const imageToRender = variantData.featured_media?.preview_image ?? this.productImage
      const imageSrc = imageToRender?.src 
      const mediaId = variantData.featured_media?.id
      const productRoot = this.closest('original-product')
      const gallery = productRoot?.querySelector('[data-product-gallery]')

      if (gallery) {
        const slides = gallery.querySelectorAll('.o-product-image-slide')
        const thumbs = gallery.querySelectorAll('.o-product-thumb')
        let targetSlide = mediaId
          ? gallery.querySelector(`.o-product-image-slide[data-media-id="${mediaId}"]`)
          : null

        if (!targetSlide && imageSrc) {
          const normalizedSrc = String(imageSrc).split('?')[0]
          targetSlide = Array.from(slides).find((slide) => {
            const bg = slide.style.backgroundImage || ''
            return bg.includes(normalizedSrc) || (normalizedSrc && bg.includes(normalizedSrc.split('/').pop()))
          })
        }

        if (targetSlide) {
          const index = targetSlide.getAttribute('data-image-index')
          slides.forEach((slide) => slide.classList.remove('is-active'))
          thumbs.forEach((thumb) => thumb.classList.remove('is-active'))
          targetSlide.classList.add('is-active')
          gallery.querySelector(`.o-product-thumb[data-thumb-index="${index}"]`)?.classList.add('is-active')
          const mainImage = gallery.querySelector('.o-product-main-image')
          if (mainImage) this.transitionFadeIn(mainImage)
        }
        return
      }

      if (!this.image) this.image = productRoot?.querySelector('.o-product-image')
      if (imageSrc && this.image) {  
        const currentImage = this.image.style.backgroundImage 
        const newImage = `url("${imageSrc}")` 
        
        if (currentImage !== newImage) {
          this.image.style.backgroundImage = newImage
          this.transitionFadeIn(this.image)
        } 
      } 
    } catch (error) {
      console.log('Error updating variant image: ', error)
    }
  }

  transitionFadeIn(element) { 
    element.classList.add('fade-in')
    setTimeout(() => {
      element.classList.remove('fade-in')
    }, 300)
  }

  initializeVariant(){
    this.getVariantData();
    this.updateMasterId();
    this.updateShippingDates();
    this.updateVariantStatuses();
    if (!this.productImage) this.getProductImage()
    this.showOptionsEle = this.querySelector('.o-variant-show-options');
    if (!this.showOptionsEle) return;
    const variantSelectEle = this.querySelector('.o-product-variant-select');
    if (variantSelectEle.tagName == 'FIELDSET'){
      variantSelectEle.appendChild(this.showOptionsEle)
    }
    this.showOptionsEle?.addEventListener('click', this.showOptions.bind(this));
    this.updateWarning();

    this.session = window.origoProfile?.session;
    this.lastProduct = this.session?.lastProduct;
    this.selectEle = this.querySelector('.o-product-variant-select');
    if (!this.lastProduct) return;
    this.productEle = this.closest('original-product');
    this.querySelectorAll('.o-variant-option').forEach(optionEle => {
      if (window.origoProfile.session.lastMatch[this.selectEle.name] == optionEle.value){
        optionEle.closest('.variant-label').classList.add('o-recommended');
      } else {
        optionEle.closest('.variant-label').classList.remove('o-recommended');
      }
    });

  }

  createNotice(text) {
    this.boundOutsideClick = this.handleOutsideClick.bind(this)
    const noticeEl = document.createElement('span')
    if (text) noticeEl.textContent = text
    noticeEl.classList = 'notice'
    window.addEventListener('click', this.boundOutsideClick)
    return noticeEl
  }

  removeNotice(notice) { 
    (notice ?? this.noticeEl)?.remove();
    window.removeEventListener('click', this.boundOutsideClick)
  }

  handleOutsideClick(evt) {
    if (!evt.target.classList.contains('notice')) {
      this.removeNotice()
    }
  }

  showOptions(){
    this.showOptionsEle.style.display = 'none';
    this.classList.remove('o-product-variant-select-disabled');
  }
  getSectionEle(){
    this.sectionEle = this.sectionEle || document.getElementById(`shopify-section-${this.dataset.section}`)
    return this.sectionEle
  }

  updateURL() {
    if (!window.oplus.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${window.oplus.currentVariant.id}`);
  }
  updateShareUrl() {
    const shareButton = this.getSectionEle().querySelector(`#Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${window.oplus.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = this.getSectionEle().querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = window.oplus.currentVariant?.id || "";
      this.closest('original-product').dataset.variantSku = window.oplus.currentVariant?.sku || "";
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    this.updateWarning();
  }
  updateWarning() {
    if (!this.showOptionsEle){ return; }
    const warningEle = this.closest('.o-product-variant')?.querySelector('.o-variant-change-warning');
    if (this.lastProduct == this.productEle?.dataset?.variantSku){
      this.getProductEle().classList.remove('o-product-guarantee-warning');
      warningEle.classList.add('o-hidden');
      this.classList.remove('o-change-warning-visible');
    } else {
      this.getProductEle().classList.add('o-product-guarantee-warning');
      this.classList.add('o-change-warning-visible');
      warningEle.classList.remove('o-hidden');
    }
  }
  updateVariantStatuses() {
    const selectElements = [...this.getSectionEle().querySelectorAll('.o-product-variant-select')];
    const positionArray = selectElements.map(ele => ele.dataset.position);
    if (positionArray?.length < 0) return;
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => selectElements[0].querySelector(':checked').value === variant[`option${positionArray[0]}`]
    );
    selectElements.forEach((select, index) => {
      if (index === 0) return;
      const optionInputs = [...select.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = selectElements[index - 1].querySelector(':checked').value;
      const variantIds = [];
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${positionArray[index - 1]}`] === previousOptionSelected)
        .map((variantOption) => {
          variantIds.push(variantOption.id);
          return variantOption[`option${positionArray[index]}`]
        });

      if (availableOptionInputsValue.indexOf(select.value) < 0 && select.tagName == 'SELECT'){
        select.classList.add('o-product-unavailable');
      } else {select.classList.remove('o-product-unavailable');}

      this.setInputAvailability(optionInputs, availableOptionInputsValue, variantIds);
    });
    this.toggleAddButton();
  }

  setInputAvailability(elementList, availableValuesList, variantIds) {
    elementList.forEach((element, index) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      let parentEle = element.closest('.variant-label').querySelector('[class*="metafield"]') || element;
      parentEle.innerHTML = this.processMetaObjectText(variantIds[index], element.dataset.metaObjectText);

      if (availableElement){
        element.dataset.outOfStock = 'false';
        // element.removeAttribute('disabled')
      } else{
        element.dataset.outOfStock = 'true';
        // element.setAttribute('disabled', true)
      }
    });
  }

  toggleAddButton() {
    const productForm = this.getSectionEle().querySelector(`#product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (window.oplus.currentVariant?.available) {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = addButton.dataset.available;
    } else {
      addButton.setAttribute('disabled', 'true');
      addButtonText.textContent = addButton.dataset.unavailable;
    }
  }

  renderProductInfo(){
    this.selectEle = this.querySelector('.o-product-variant-select');
    fetch(
      `${this.dataset.url}?variant=${window.oplus.currentVariant.id}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {

        this.getSectionEle().querySelectorAll(`.o-p-product select`).forEach(select => {
          select.setAttribute('data-product-price', window.oplus.currentVariant.price);
        });
        // on variant change, update the bottom tag and the longtext
        const metafield = this.selectEle.getAttribute('name');
        const metafieldValue = this.selectEle.querySelector(':checked').value?.toLowerCase();
        if(metafieldValue?.length > 0){

          const metaObject = this.getMetaObject(metafield)[`${metafieldValue}`.toLowerCase()];
          
          const parentElement = this.selectEle.closest('.o-product-advantage');
          const bottomTagElement = parentElement.querySelector('.o-product-bottom-tag');
          if (bottomTagElement){animateElementChange(bottomTagElement);}
          setTimeout(()=>{
            bottomTagElement.innerHTML =this.processMetaObjectText(window.oplus.currentVariant.id, metaObject?.text, this.selectEle.querySelector(':checked')?.value) || "&nbsp;";
          },originalTimeoutDuration)
        
        }
      });
  }
  setUnavailable() {
    const button = this.getSectionEle().querySelector(`#product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const priceArray = this.getSectionEle().querySelector('[class*="price-number"]');
    const inventory = this.getSectionEle().querySelector(`#Inventory-${this.dataset.section}`);
    const pricePerItem = this.getSectionEle().querySelector(`#Price-Per-Item-${this.dataset.section}`);
    const volumeNote = this.getSectionEle().querySelector(`#Volume-Note-${this.dataset.section}`);
    const volumeTable = this.getSectionEle().querySelector(`#Volume-${this.dataset.section}`);
    const qtyRules = this.getSectionEle().querySelector(`#Quantity-Rules-${this.dataset.section}`);
    const deliveryDates = this.getSectionEle().querySelector(`.delivery-dates`);

    // if (!addButton) return;
    // addButtonText.textContent = window.variantStrings?.unavailable | addButton.dataset.unavailable;

    if (priceArray?.length > 0) priceArray.map(p => p.classList.add('hidden'));
    if (inventory) inventory.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }
  updateShippingDates() {
    const deliveryDatesElement = this.getSectionEle()?.querySelector('.delivery-dates');
    if (!deliveryDatesElement || !window.oplus?.currentVariant) return;

    const shipmentDate = this.getVariantsMetafields()[window.oplus.currentVariant.id]?.shipment_date;
    const variant = window.oplus.currentVariant;
    const result = window.OplusShipDate.calculate({
      ...window.OplusShipDate.parseFromElement(deliveryDatesElement),
      shipmentDate,
      inventoryQuantity: variant.inventory_quantity,
      inventoryManagement: variant.inventory_management,
      available: variant.available,
    });
    window.OplusShipDate.applyToElement(deliveryDatesElement, result);
  }
 
  getVariant2Data(){
    this.variant2Data = this.variant2Data || JSON.parse(this.getSectionEle().querySelector('#variantData').textContent)[1].variants;
    return this.variant2Data;
  }
  getVariants2Metafields(){
    this.variants2Metafiels = this.variant2Metafields || JSON.parse(this.getSectionEle().querySelector('#variantData').textContent)[1].metafields.variantsCustom;
    return this.variants2Metafiels;
  }
  getMetaObject(metaField){
    metaField = metaField.toLowerCase();
    this.metaObject = this.metaObject || 
    JSON.parse(JSON.stringify(this.parseAsJSObject(document.getElementById(`metaObject-${metaField}`)?.textContent)));
    return this.metaObject;
  }
}
customElements.define('original-variant', OriginalVariant);

class OriginalGuarantee extends OriginalElement {
  constructor() {
    super();
    this.setModal();
  }
}
customElements.define('original-guarantee', OriginalGuarantee);

class OriginalCartIntercept extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick);
  }
  onClick(e) {
    e.stopPropagation();
    const inputEle = e.target.closest('.cart__item-sub')?.querySelector('[id*="cart_updates"]');
    let updates = {};
    updates[inputEle.dataset.id.toString()] = e.target.dataset.type === 'minus' ? (Number(inputEle.value) - 1) | 0 : 0;

  
    this.closest('form').querySelectorAll(`[data-parent-item="${this.dataset.sku}"] [id*="cart_updates"], [data-parent-item="${this.dataset.id}"] [id*="cart_updates"]`).forEach(inputEle => {
      updates[inputEle.dataset.id.toString()] = e.target.dataset.type === 'minus' ? (Number(inputEle.value) - 1) | 0 : 0;
    });

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      window.location.href = window.location.href;
    })
  }
}
customElements.define('original-cart-intercept', OriginalCartIntercept);

class OriginalTextblock extends OriginalElement {
  constructor() {
    super();
    this.advantageName = this.dataset.name;
    this.textElement = this.querySelector('.o-product-textblock__text');
    this.initializeTextblock();
  }

  initializeTextblock() {
    // Find parent product component
    const product = document.querySelector('original-product');
    if (!product) return;

    // Find matching advantage
    const advantage = product.querySelector(`.o-product-advantage[data-name="${this.advantageName}"]`);
    if (!advantage) return;

    // Handle initial state
    this.updateTextblock(advantage);

    // Listen for changes on radio buttons/checkboxes
    advantage.addEventListener('change', () => this.updateTextblock(advantage));
  }

  updateTextblock(advantage) {
    // Get selected value
    const checkedInput = advantage.querySelector(':checked');
    if (!checkedInput) return;

    // Find metafield element
    const metafieldValue = checkedInput.value;
    const metaObjectElement = document.querySelector(`#metaObject-${this.advantageName}`);
    if (!metaObjectElement) return;

    // Parse configuration
    try {

      const JSONObject = JSON.parse(JSON.stringify(this.parseAsJSObject(metaObjectElement.textContent)));
      const matchingEntry = JSONObject[`${this.advantageName}-${metafieldValue}`];
      
      if (matchingEntry?.longtext) {
        this.textElement.innerHTML = matchingEntry.longtext;
      }
    } catch (error) {
      console.error('Error parsing metafield JSON:', error);
    }
  }
}
customElements.define('original-textblock', OriginalTextblock);



class OrigoColors extends OriginalElement  {
  constructor() {
    super();
    // the change listener comes first, so a bad profile can never leave the picker dead
    this.addEventListener('change', this.colorClickHandler);
    const init = () => {
      window.origoProfile = window.normalizeOrigoProfile(window.origoProfile);
      try { this.includeColors(); } catch (e) { console.error('origo-colors includeColors', e); }
      try { this.initializeColors(); } catch (e) { console.error('origo-colors initializeColors', e); }
    };
    if (window.origoProfile){
      init();
    } else {
      document.addEventListener('profileLoaded', init);
    }
  }

  initializeColors() {
    window.origoProfile = window.normalizeOrigoProfile(window.origoProfile);
    const storedColor = window.origoProfile.session.colors[this.dataset.id.replace(/^ski-/, '')];
    if (!storedColor) return;
    this.querySelectorAll('input[type="radio"]').forEach(input => {
      input.checked = input.value.toLowerCase().indexOf(storedColor.toLowerCase()) > -1;
    });
  }
  colorClickHandler() {
    window.origoProfile = window.normalizeOrigoProfile(window.origoProfile);
    try { this.excludeColors(); } catch (e) { console.error('origo-colors excludeColors', e); }
    try { this.includeColors(); } catch (e) { console.error('origo-colors includeColors', e); }
    setTimeout(() => {window.setSVG(true).then()}, 50);
  }

  excludeColors(){
    const exclude = this.getExclude();
    if (exclude?.hasOwnProperty(this.dataset.id) && exclude[this.dataset.id]) {
      // reset disabled input for all colors
      this.getColorElements().forEach(colorEle => {
        colorEle.querySelectorAll('input')?.forEach(input => {
          input.disabled = false;
        });
      });
      for (const color in exclude[this.dataset.id]) {
        if ( this.querySelector(':checked')?.value.indexOf(color) >= 0){
          for (const key in exclude[this.dataset.id][color]){
            let disabledCheckedColor;
            this.getColorElements().forEach(colorEle => {
              if (colorEle.dataset.id === "ski-" + key) {
                colorEle.querySelectorAll('input').forEach(input => {
                  if (exclude[this.dataset.id][color][key].indexOf(input.value) > -1) {
                    if (input.checked) {
                      disabledCheckedColor = true;
                      input.checked = false;
                    }
                    input.disabled = true;
                  }
                });
                if (disabledCheckedColor) {
                  for (const input of colorEle.querySelectorAll('input')){
                    if (input.disabled !== true) {
                      input.checked = true;
                      break
                    }
                  }
                }

              }
            });
          }
        }
      }
    }
  }
  /**
   * Includes colors based on the logic of the metaobject 'origo_color_logic'.
   * This function:
   * 1. Checks for "included colors" as JSON in the script tag (comming from the metaobject)
   * 2. Iterates through each category in the included colors (e.g. 'ski', 'logo', 'info', ...)
   * 3. Finds the checked color for the current category
   * 4. If a color is checked, it processes the connected categories and colors (e.g. 'logoBottom')
   * 5. For connected categories with a single color, it sets that color directly (e.g. 'riginal')
   * 6. For connected categories with multiple colors, it updates the UI and session data (e.g. 'ski' selection changes the colors for 'logo')
   */
  includeColors(){
    if (!this.getInclude()) return;
    for (const category in this.includedColors) {
      if (!this.includedColors.hasOwnProperty(category)) continue

      // Will be triggered for every category, we have to find the checked color for each category individually
      const checkedColorElement = this.closest('.o-colors').querySelector(`origo-colors[data-id="ski-${category}"] :checked`);
      const colors = this.includedColors[category];

      for (const color in colors) {
        if (!colors.hasOwnProperty(color)) continue;
        if (checkedColorElement) {
          if (color !== checkedColorElement.value) continue;
          const connectedCategories = colors[color];

          for (const connectedCategory in connectedCategories) {
            const connectedColors = connectedCategories[connectedCategory];
            // if the connected category has only one color, set it as the color no additional logic is needed
            // important must include the "#" for the getColor function to work
            if(connectedColors.length === 1){
              window.origoProfile.session.colors[connectedCategory] = connectedColors[0];
              continue;
            }
            const connectedColorEle = this.closest('.o-colors').querySelector(`origo-colors[data-id="ski-${connectedCategory}"]`);
            const includedColorElements = [];
            if (connectedColorEle) {
              const oldCheckedConnectedColorEle = connectedColorEle.querySelector(`:checked`);

              for (const colorEle of connectedColorEle.querySelectorAll('input')) {
                const included = (connectedColors.indexOf(colorEle.value) > -1);
                if (included) {
                  includedColorElements.push(colorEle);
                } else {
                  colorEle.checked = false;
                }
                colorEle.dataset.included = included.toString();
              }
              // only continue if the old checked color is not in the connected colors
              if (connectedColors.indexOf(oldCheckedConnectedColorEle?.value) >= 0) continue;

              // automatically select the best color (closest hue)
              const targetHue = this.getBrightnessSaturationHue(checkedColorElement.value).hue;
              const sortedColors = includedColorElements.map(colorEle => {
                const { brightness, saturation, hue } = this.getBrightnessSaturationHue(colorEle.value);
                return { colorEle, hue, saturation, hueDistance: Math.abs(hue - targetHue) };
              }).sort((a, b) => a.hueDistance - b.hueDistance);

              const topMatches = sortedColors.slice(0, 3);

              // Choose the one with the highest saturation among the top matches
              const bestMatch = topMatches.reduce((prev, current) => {
                return (current.saturation > prev.saturation) ? current : prev;
              });
              bestMatch.colorEle.checked = true;
            }
          }
        }
        if (colors.length === 1) {
          window.origoProfile.session.colors[category] = colors[0];
        }
      }
    }
  }

  /**
   * @param hex
   * @returns {(number|number|number)[]}
   * brightness > .5 is bright
   * saturation < .25 is gray
   */
  getBrightnessSaturationHue(hex) {
    hex = hex.replace(/^#/, '');
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    const brightness = ((r * 0.299) + (g * 0.587) + (b * 0.114));

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const lightness = (max + min) / 2;
    let saturation = 0;
    let hue = 0;

    if (max !== min) {
      const delta = max - min;
      saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

      switch (max) {
        case r:
          hue = ((g - b) / delta + (g < b ? 6 : 0)) / 6;
          break;
        case g:
          hue = ((b - r) / delta + 2) / 6;
          break;
        case b:
          hue = ((r - g) / delta + 4) / 6;
          break;
      }
    }

    return { brightness, saturation, hue };
  }
  getColorElements(){
    this.origoColorElements = this.origoColorElements
                              || this.closest('.o-colors').querySelectorAll('origo-colors');
    return this.origoColorElements;
  }
  getId(){
    this.id = this.id || this.dataset.id;
    return this.id;
  }
  getInclude(){
    this.includedColorsEle = this.includedColorsEle
                            || this.closest('.o-colors').querySelector('.o-question-color-include');
    if (!this.includedColorsEle?.textContent) return;
    this.includedColors = this.includedColors || JSON.parse(this.includedColorsEle?.textContent);
    return this.includedColors;
  }
  getExclude(){
    this.excludedCoorsEle = this.excludedCoorsEle
                            || this.closest('.o-colors').querySelector('.o-question-color-exclude');
    if (!this.excludedCoorsEle?.textContent) return;
    this.excludedColors = this.excludedColors || JSON.parse(this.excludedCoorsEle?.textContent);
    return this.excludedColors;
  }
}

customElements.define('origo-colors', OrigoColors);

!customElements.get('promo-banner') && customElements.define('promo-banner', class PromoBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initListener()
  }

  initListener() {
    window.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick(evt) { 
    if (evt.target.classList.contains('promo-banner-notice-trigger')) {
      this.toggleAttribute('show-notice')
    } else {
      this.removeAttribute('show-notice')
    }
  }
}) 
